import { LoaderFunctionArgs } from 'react-router-dom'
import { protectedLoader } from './protectLoader'
import { PORTAL_ADMIN, PORTAL_SUPPORT } from '.'
import { lazyRoute } from '../utils/lazyRoute'

const resellersRoutes = [
  {
    path: '/resellers',
    lazy: lazyRoute(() => import('../pages/Portal/Resellers')),
    loader: (args: LoaderFunctionArgs) =>
      protectedLoader(args, {
        allowedRoles: [PORTAL_ADMIN, PORTAL_SUPPORT],
      }),
  },
]

export default resellersRoutes
